import React, { useState, useEffect, useRef } from 'react';
import "../../../assets/css/flightmonitor/flightmonitor.css";
import Header from "../../../Components/Header/Header";

import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark, faHourglass, faCheck, } from '@fortawesome/free-solid-svg-icons';
import ProgressBar from 'react-bootstrap/ProgressBar';
import show from '../../../assets/images/show.png';



const TruckMonitor = () => {

    const [ftmDetails, setFtmDetails] = useState(false);
    const [switchSec, setSwitchSec] = useState(false);

    const handleSwitch = () => {
        setSwitchSec(switchSec ? false : true)
    }

    const backToFtm = () => setFtmDetails(false)
    return (
        <div className="">
            <Header page_type='TKM' logo_url='/TruckMonitor' />
            <div className='main-panel rounded'>

                <div className='search-panel'>
                    <div className='search-left'>
                        <Form.Control type="text" placeholder="Search Truck..." />
                        <div className='search-icon'>
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </div>
                    </div>
                    <button onClick={handleSwitch}>Switch</button>
                </div>
                <div className='trk-prs-pnl-main'>
                    <Row>
                        {!switchSec ?
                            <>
                                <Col xs={12} lg={4} md={6}>
                                    <div className='trk-prs-pnl trk-prs-pnl-1'>
                                        <div className='trk-opn'>
                                            <h4>Open <span>2</span></h4>
                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-1'>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={30} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-1'>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={30} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-1'>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={30} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} lg={4} md={6}>
                                    <div className='trk-prs-pnl trk-prs-pnl-2'>
                                        <div className='trk-opn'>
                                            <h4>In Progress <span>3</span></h4>
                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-2'>
                                                    <FontAwesomeIcon icon={faHourglass} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-2'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={50} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />

                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-3'>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-3'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={90} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-2'>
                                                    <FontAwesomeIcon icon={faHourglass} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-2'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={50} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} lg={4} md={6}>
                                    <div className='trk-prs-pnl trk-prs-pnl-3'>
                                        <div className='trk-opn'>
                                            <h4>Completed <span>1</span></h4>
                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-3'>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-3'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={95} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </>
                            :
                            <>
                                <Col xs={12} lg={4} md={6}>
                                    <div className='trk-prs-pnl trk-prs-pnl-3'>
                                        <div className='trk-opn'>
                                            <h4>Low <span>1</span></h4>
                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-3'>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-3'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={95} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} lg={4} md={6}>
                                    <div className='trk-prs-pnl trk-prs-pnl-2'>
                                        <div className='trk-opn'>
                                            <h4>Medium <span>3</span></h4>
                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-2'>
                                                    <FontAwesomeIcon icon={faHourglass} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-2'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={50} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />

                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-3'>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-3'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={90} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-2'>
                                                    <FontAwesomeIcon icon={faHourglass} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left-2'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={50} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} lg={4} md={6}>
                                    <div className='trk-prs-pnl trk-prs-pnl-1'>
                                        <div className='trk-opn'>
                                            <h4>Critical <span>2</span></h4>
                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-1'>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={30} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-1'>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={30} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className='trk-load-wrap'>
                                            <div className='trk-load-box'>
                                                <div className='trk-load-head'>
                                                    <h4>RFS Loading (Truck No)</h4>
                                                    <span>Szamocki</span>
                                                </div>
                                                <div className='trk-load-right'>
                                                    <h4>Door No. 15</h4>
                                                    <sapn className="trk-view">
                                                        <img src={show} alt="" />
                                                    </sapn>
                                                </div>
                                            </div>
                                            <div className='trk-pgrs-wrap'>
                                                <span className='trk-pgrs-icon trk-pgrs-icon-1'>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </span>
                                                <div className='trk-pgrs pgrstm-left'>
                                                    <h5>Time left 1:30</h5>
                                                    <ProgressBar now={30} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Col>
                            </>
                        }
                    </Row>
                </div>

            </div>
        </div>
    )
}

export default TruckMonitor;
